import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'support-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class SupportIndexComponent implements OnInit {
  support: any;
  uid: string = '';
  isLoading: boolean = true;

  constructor(
      private route: ActivatedRoute,
      public auth: AuthService,
      private shared: SharedService
    ) {}

  ngOnInit() {
    this.uid = this.route.snapshot.paramMap.get('uid');

    this.isLoading = true;
    this.auth.fetchVTuber(this.uid)
    .then(response => {
        if (response.exists) {
            let vtuber = response.data();
            if (vtuber.status === AuthService.VTUBER_REVIEW_STATUS
              || vtuber.events === undefined
              || vtuber.is_avatar_tested !== true
              || vtuber.is_public === false) {
                this.shared.redirect('/');
            } else {
                this.support = vtuber;
                this.support.plans = this.support.plans
                .filter(item => {
                  return item.status === undefined || item.status === 'approve'
                })
                .sort((a, b) => {
                  if (parseInt(a.amount) > parseInt(b.amount)) return 1;
                  if (parseInt(a.amount) < parseInt(b.amount)) return -1;
                  return 0;
                })
                this.isLoading = false;
            }
        } else {
            this.shared.redirect('/');
        }
    }).catch(() => {
        this.shared.redirect('/');
    })

    this.shared.removeCookie(SharedService.CURRENT_VTUBER)
  }

  openSupport(index) {
    this.support.currentPlan = this.support.plans[index]
    if (this.auth.user) { // Already Login
      this.shared.setCookie(SharedService.CURRENT_VTUBER, JSON.stringify(this.support))
      this.shared.redirect('/card/pay');
    } else {
      this.shared.setCookie(SharedService.CURRENT_VTUBER, JSON.stringify(this.support))
      this.shared.redirect('/login')
    }
  }

  needShow(plan) {
    if (this.auth.user === undefined) return true;
    if (this.auth.user && this.auth.user.role === AuthService.VTUBER_ROLE) return false;

    if (this.auth.user.plans === undefined) return true;

    return this.auth.user.plans.filter(item => (item.plan_uid === plan.uid) && (item.stoppedAt === undefined || item.stoppedAt > Date.now())).length === 0;
  }
}
